var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferenceUploadedDocumentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21048_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#235594"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.4141 11.1669H24.0199L21.4141 8.47998V11.1669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.6098 13.043H13.8551V14.2988H20.6098V13.043ZM20.6558 18.1627L17.2324 14.7393L13.8091 18.1627L14.6967 19.0525L16.6034 17.1457V23.1969H17.8614V17.1457L19.7682 19.0525L20.6558 18.1627ZM24.4649 11.8222V26H10V8H20.761V11.4957C20.761 11.6754 20.9078 11.8222 21.0875 11.8222H24.4649Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceUploadedDocumentLogo);
export default __webpack_public_path__ + "static/media/ReferenceUploadedDocumentLogo.64dc67a753c9747d887e540a6c5da892.svg";
export { ForwardRef as ReactComponent };